import React, { memo } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Routes from '../Routes/Routes'
import AxiosAuthBootstrap from '../api/AxiosAuthBootstrap'
import PushNotificationBootstrap from '../api/PushNotificationBootstrap'
import OrganizationInactiveBanner from '../components/common/OrganizationInactiveBanner'
import ChatDock from '../components/chat/ChatDock'

const Layout = () => {
  return (
    <>
      <AxiosAuthBootstrap />
      <PushNotificationBootstrap />
      <OrganizationInactiveBanner />
      <ChatDock />
      <Routes />
      <ToastContainer />
    </>
  )
}

export default memo(Layout)
